module.exports = __webpack_public_path__ + "img/1 (90).2fe49097.png";